export { default } from './OpportunityAI';
